export default __webpack_public_path__ + "img/Woodtexure-full.png";